import Done from './Done';
import Email from './Email';
import { Facebook, FacebookMini } from './Facebook';
import InclineArrow from './InclineArrow';
import Link from './Link/Link';
import Minus from './Minus';
import Pin from './Pin';
import Plus from './Plus';
import Reddit from './Reddit';
import Telegram from './Telegram';
import Twitter from './Twitter';
import WhatsApp from './WhatsApp';
import Instagram from './instagram';

export {
  Email,
  Facebook,
  FacebookMini,
  Link,
  Reddit,
  Telegram,
  Twitter,
  WhatsApp,
  Done,
  Instagram,
  Plus,
  Minus,
  Pin,
  InclineArrow,
};
